import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ResultadoBusquedaSolicitudes } from '../model/resultado-busqueda-solicitudes';
import { ServiceDetails } from '../model/solicitud-servicio';
import { SolicitudesAprobadas, SolicitudesSearch } from '../model/solicitudes';
import { TiposServicio } from '../model/tipo-servicio';
import { TipoServicioService } from './tipo-servicio.service';



@Injectable()
export class SolicitudesService {
  PATH = environment.API_BASE + '/Services';

  constructor(
    private http: HttpClient,
    private tipoServicioService: TipoServicioService
  ) { }

  // Consulta las solicitudes de servicio que cumplen los filtros indicados. Permite paginación
  getAllSolicitudes(filters: SolicitudesSearch, n: number, m: number): Observable<ResultadoBusquedaSolicitudes> {
    return this.http.post<ResultadoBusquedaSolicitudes>(this.PATH + '/' + n + '/' + m, filters)
      .pipe(map((result: ResultadoBusquedaSolicitudes) => ResultadoBusquedaSolicitudes.toModel(JSON.stringify(result))));
  }

  aprobarSolicitud(idSolicitud: number, aprobada: number): Observable<SolicitudesAprobadas> {
    const serviceDetails = new ServiceDetails();
    serviceDetails.Id = idSolicitud;
    return this.http.post<SolicitudesAprobadas>(this.PATH + '/AprobarSolicitud/' + aprobada, serviceDetails)
      .pipe(map((result: SolicitudesAprobadas) => SolicitudesAprobadas.toModel(JSON.stringify(result))));
  }

  descargarDetalleSolicitud(idSolicitud: number): Observable<any> {
    return this.http.get(`${this.PATH}/PrintSolicitud/${idSolicitud}/${(new Date()).getTimezoneOffset()}`, { responseType: 'blob' });
  }

  rollbackSolicitudFinalizada(idsolicitud: number): Observable<boolean> {
    const uri = this.PATH + '/RollbackSolicitud?idSolicitud=' + idsolicitud;
    return this.http.get(uri)
      .pipe(map((r: any) => {
        return r;
      }));
  }

  cancelarSolicitudInicial(idsolicitud: number, rollback = false): Observable<{ isok: boolean, msg: string }> {
    const uri = this.PATH + '/CancelarSolicitud/' + idsolicitud + '?Rollback=' + rollback;
    return this.http.get<{ isok: boolean, msg: string }>(
      uri);
  }

  rollbackContenidoFinalizado(idcontenido: number): Observable<boolean> {
    const uri = this.PATH + '/RollbackContenido?idContenido=' + idcontenido;
    return this.http.get(uri)
      .pipe(map((r: any) => {
        return r;
      }));
  }

  actualizarUrgenteNormalSolicitud(idSolicitud: number, esUrgente: boolean): Observable<any> {
    const uri = this.PATH + '/updateNormalUrgente/' + idSolicitud + '/' + esUrgente;
    return this.http.get(uri);
  }

  actualizarOriginalCopiaSolicitud(idSolicitud: number, esOriginal: boolean): Observable<any> {
    const uri = this.PATH + '/updateCopiaOriginal/' + idSolicitud + '/' + esOriginal;
    return this.http.get(uri);
  }

  comprobarTieneCopiaOriginal(idCliente: number): Observable<boolean> {
    const uri = this.PATH + '/comprobarTieneCopiaOriginal/' + idCliente;
    return this.http.get<boolean>(uri);
  }

}
